window.OKJS = window.OKJS || {};
(function (OKJS) {
  OKJS.Blocks = {
    settings: {},
    init: function () {
      // iblocks
      var iBlocks = document.querySelectorAll('.js-sticky-iblock');
      if (iBlocks.length > 0 && window.innerWidth > 1280) {
        OKJS.Blocks.setupStickyIBlock(iBlocks);
      }

      // animated headings
      var animatedHeadings = document.querySelectorAll('.js-ani-heading');
      if (animatedHeadings.length > 0) {
        OKJS.Blocks.animateHeadings(animatedHeadings);
      }

      // overflowbars
      var overflowBars = document.querySelectorAll('.js-overflowbar');
      if (overflowBars.length > 0) {
        OKJS.Blocks.setupOverflowBars(overflowBars);
      }

      // cc blocks that have fancy scroll effect
      var ccScrolls = document.querySelectorAll('.js-cc-scroll');
      if (
        ccScrolls.length > 0 &&
        window.innerWidth > 768 &&
        !document.querySelector('.edit-mode')
      ) {
        OKJS.Blocks.setupCcScrolls(ccScrolls);
      }

      // toggle function for data spec content elements
      var dataSpecs = document.querySelectorAll('.js-data-specs');
      if (dataSpecs.length > 0) {
        OKJS.Blocks.setupDataSpecs(dataSpecs);
      }

      // toggle function for data spec content elements
      var anchorLinksElem = document.querySelector('.js-anchor-links');
      if (anchorLinksElem) {
        OKJS.Blocks.setupAnchorLinks(anchorLinksElem);
      }

      // cc slider elements
      var ccSliders = document.querySelectorAll('.js-cblock-slider');
      if (ccSliders.length > 0) {
        OKJS.Blocks.setupCcSliders(ccSliders);
      }

      // cc station block
      var countUpElem = document.querySelectorAll('.js-count-up');
      for (i = 0; i < countUpElem.length; ++i) {
        OKJS.Global.counterSetup(countUpElem[i]);
      }

      // facts and tips aka "fish and chips"
      var factsBlocks = document.querySelectorAll('.js-facts-scroll');
      if (factsBlocks.length > 0) {
        OKJS.Blocks.setupFactsScrolls(factsBlocks);
      }

      // el product comparison block toggle
      var elToggles = document.querySelectorAll('.js-elprdc-toggle');
      if (elToggles.length > 0) {
        OKJS.Blocks.setupElToggles(elToggles);
      }
    },
    setupStickyIBlock: function (iBlocks) {
      var throttledIBlockUpdate = OKJS.Global.throttle(
        function () {
          OKJS.Blocks.stickyIBlockUpdate(iBlocks);
        },
        150,
        { trailing: false }
      );
      var throttledIBlockUpdatePlacement = OKJS.Global.throttle(
        function () {
          OKJS.Blocks.stickyIBlockUpdatePlacement(iBlocks);
        },
        500,
        { trailing: true }
      );

      window.addEventListener(
        'scroll',
        function () {
          requestAnimationFrame(throttledIBlockUpdate);
        },
        Modernizr.passiveeventlisteners ? { passive: true } : false
      );
      window.addEventListener(
        'resize',
        function () {
          requestAnimationFrame(throttledIBlockUpdatePlacement);
        },
        Modernizr.passiveeventlisteners ? { passive: true } : false
      );

      OKJS.Blocks.stickyIBlockUpdatePlacement(iBlocks);
    },
    stickyIBlockUpdatePlacement: function (iBlocks) {
      for (var i = 0; i < iBlocks.length; i++) {
        var fixedCon = iBlocks[i].querySelector('.iblock__fixed');
        fixedCon.dataset.top =
          fixedCon.getBoundingClientRect().top + window.pageYOffset;
        fixedCon.dataset.left =
          fixedCon.getBoundingClientRect().left + window.pageXOffset;
      }
    },
    stickyIBlockUpdate: function (iBlocks) {
      for (var i = 0; i < iBlocks.length; i++) {
        var cBlocksCon = iBlocks[i].querySelector('.iblock__cblocks'),
          fixedCon = iBlocks[i].querySelector('.iblock__fixed'),
          verticalLimit =
            cBlocksCon.getBoundingClientRect().bottom - fixedCon.offsetHeight,
          scrollPosition = window.pageYOffset;

        if (scrollPosition > fixedCon.dataset.top) {
          fixedCon.classList.add('fixed');
          if (verticalLimit > 0) {
            fixedCon.setAttribute(
              'style',
              'position: fixed; left:' +
                fixedCon.dataset.left +
                'px; top: 20px;'
            );
          } else {
            fixedCon.setAttribute(
              'style',
              'position: absolute; left: 40px; top: inherit; bottom:' +
                (cBlocksCon.offsetHeight + 40) * -1 +
                'px;'
            );
          }
        } else {
          fixedCon.classList.remove('fixed');
          fixedCon.setAttribute('style', '');
        }
      }
    },
    animateHeadings: function (animatedHeadings) {
      for (var i = 0; i < animatedHeadings.length; i++) {
        var headingsSrc =
          animatedHeadings[i].querySelector('.ani-heading__txt');

        if (headingsSrc) {
          // View https://github.com/mattboldt/typed.js for documentation
          var type = new Typed(
            animatedHeadings[i].querySelector('.ani-heading__input'),
            {
              stringsElement: headingsSrc,
              typeSpeed: 50,
              backDelay: 3000,
              backSpeed: 20,
              loop: true,
            }
          );
        }
      }
    },
    setupOverflowBars: function (overflowBars) {
      var activeOnMobile;

      if (overflowBars && overflowBars.length > 0) {
        for (var i = 0; i < overflowBars.length; i++) {
          activeOnMobile = overflowBars[i].dataset.activeOnMobile
            ? true
            : false;

          if (activeOnMobile || (!activeOnMobile && window.innerWidth > 480)) {
            OKJS.Blocks.activateOverflowBar(overflowBars[i]);
          }
        }
      } else {
        activeOnMobile = overflowBars.dataset.activeOnMobile ? true : false;

        if (activeOnMobile || (!activeOnMobile && window.innerWidth > 480)) {
          OKJS.Blocks.activateOverflowBar(overflowBars);
        }
      }

      // click event for the buttons
      var overflowBarButtons = document.querySelectorAll(
        '.js-overflowbar-button'
      );
      for (var b = 0; b < overflowBarButtons.length; b++) {
        var btn = overflowBarButtons[b];
        btn.addEventListener('click', function (e) {
          var simpleBar = e.currentTarget.closest('.simplebar-content'),
            scrollWidth =
              simpleBar.querySelector('.overflowbar__item').clientWidth * 2;
          direction = e.currentTarget.dataset.direction;

          if (direction === 'left') {
            simpleBar.scrollLeft = simpleBar.scrollLeft - scrollWidth;
          } else {
            simpleBar.scrollLeft = simpleBar.scrollLeft + scrollWidth;
          }
        });
      }
    },
    activateOverflowBar: function (overflowBar) {
      var overflowBarItems = overflowBar.querySelectorAll('.overflowbar__item'),
        scrollPxConst = Number(window.innerWidth < 769 ? 80 : 160),
        scrollPx = scrollPxConst,
        style;

      //calc the actual width of the scroll area
      for (var s = 0; s < overflowBarItems.length; s++) {
        style =
          overflowBarItems[s].currentStyle ||
          window.getComputedStyle(overflowBarItems[s]);
        scrollPx =
          scrollPx +
          Number(
            overflowBarItems[s].clientWidth +
              parseFloat(style.marginLeft !== 'auto' ? style.marginLeft : 0) +
              parseFloat(style.marginRight !== 'auto' ? style.marginRight : 0)
          );
      }

      // test if there are too many qlinks = activate the simplebar
      if (
        scrollPx >
        overflowBar.querySelector('.overflowbar__wrap').clientWidth + 100
      ) {
        // activate the simplebar script
        var sb = new SimpleBar(overflowBar.querySelector('.overflowbar__wrap')),
          simpleBar = overflowBar.querySelector('.simplebar-content');

        // scroll to the center
        //simpleBar.scrollLeft = ((scrollPx / 2) - (simpleBar.clientWidth / 2));

        // scroll a little bit
        if (
          overflowBar.dataset.rollingStart === 'true' &&
          overflowBar.dataset.activeOnMobile === 'true'
        ) {
          simpleBar.scrollLeft = scrollPxConst / 2;
        }
      }
    },
    setupCcScrolls: function (ccScrolls) {
      var throttledCcScrollUpdate = OKJS.Global.throttle(
          function () {
            OKJS.Blocks.ccScrollUpdate(ccScrolls);
          },
          100,
          { trailing: false }
        ),
        throttledCcScrollUpdateVars = OKJS.Global.throttle(
          function () {
            OKJS.Blocks.ccScrollUpdateCons(ccScrolls);
          },
          500,
          { trailing: true }
        );

      window.addEventListener(
        'scroll',
        function () {
          requestAnimationFrame(throttledCcScrollUpdate);
        },
        Modernizr.passiveeventlisteners ? { passive: true } : false
      );
      window.addEventListener(
        'resize',
        function () {
          requestAnimationFrame(throttledCcScrollUpdateVars);
        },
        Modernizr.passiveeventlisteners ? { passive: true } : false
      );

      OKJS.Blocks.ccScrollUpdateCons(ccScrolls);
    },
    ccScrollUpdateCons: function (ccScrolls) {
      // update the top, bottom and left constants so that we don't need to do it ALL the time
      for (var i = 0; i < ccScrolls.length; i++) {
        ccScrolls[i].querySelector('.cblock__mediacon').style.height =
          window.innerHeight + 'px';
        ccScrolls[i].dataset.top =
          ccScrolls[i].getBoundingClientRect().top + window.pageYOffset;
        ccScrolls[i].dataset.bottom =
          +ccScrolls[i].dataset.top + ccScrolls[i].offsetHeight;

        const main = document.querySelector('.page-main');
        const anno2023Design = main.classList.contains('anno-2023-design');

        if (anno2023Design === false) {
          // make sure the left is correct regarding the left-nav bar in old design
          if (document.querySelector('.page-main__nav')) {
            ccScrolls[i].dataset.left =
              document.querySelector('.wrap').offsetLeft +
              document.querySelector('.page-main__nav').offsetWidth;
          } else {
            ccScrolls[i].dataset.left =
              document.querySelector('.wrap').offsetLeft;
          }
        } else {
          // make sure the left is correct regarding the left-nav bar in anno-2023-design
          if (document.querySelector('.page-main__nav')) {
            ccScrolls[i].dataset.left =
              document.querySelector('.wrap').offsetLeft +
              document.querySelector('.page-main__nav').offsetWidth +
              24;
          } else {
            ccScrolls[i].dataset.left =
              document.querySelector('.wrap').offsetLeft + 24;
          }
        }
      }
      // make sure the view is updated with the new constants
      OKJS.Blocks.ccScrollUpdate(ccScrolls);
    },
    ccScrollUpdate: function (ccScrolls) {
      for (var i = 0; i < ccScrolls.length; i++) {
        var scrollPositionTop =
            window.pageYOffset || document.documentElement.scrollTop,
          mediaConImg = ccScrolls[i].querySelector('.cblock__img');

        // have we scrolled past the top of the ccScroll element?
        if (scrollPositionTop > ccScrolls[i].dataset.top) {
          var scrollPositionBottom =
              (window.pageYOffset || document.documentElement.scrollTop) +
              window.innerHeight,
            mediaCon = ccScrolls[i].querySelector('.cblock__mediacon');

          // and is the viewport bottom above the bottom of the element?
          if (scrollPositionBottom < ccScrolls[i].dataset.bottom) {
            mediaConImg.style.left = ccScrolls[i].dataset.left + 'px';
            mediaConImg.style.width = ccScrolls[i].offsetWidth / 2 + 'px';
            mediaCon.style.top = '0px';
            ccScrolls[i].classList.add('fixed');
          } else {
            ccScrolls[i].classList.remove('fixed');
            mediaConImg.style.width = '';
            mediaCon.style.top =
              ccScrolls[i].offsetHeight - window.innerHeight + 'px';
          }
        } else {
          ccScrolls[i].classList.remove('fixed');
          mediaConImg.style.width = '';
        }
      }
    },
    setupDataSpecs: function (dataSpecs) {
      for (var i = 0; i < dataSpecs.length; i++) {
        var toggleBtns = dataSpecs[i].querySelectorAll('.flex-table__row');

        for (var j = 0; j < toggleBtns.length; j++) {
          // click event for the arrow
          toggleBtns[j].addEventListener('click', function (e) {
            var toggleBtn = e.currentTarget.querySelector(
                '.flex-table__expand'
              ),
              thisRow = e.currentTarget;

            if (
              thisRow.parentElement.classList.contains(
                'flex-table--expand-desktop'
              ) ||
              window.innerWidth < 768
            ) {
              if (thisRow.classList.contains('row-active')) {
                toggleBtn.classList.remove('active');
                thisRow.classList.remove('row-active');
                thisRow.nextElementSibling.classList.remove('active');
              } else {
                toggleBtn.classList.add('active');
                thisRow.classList.add('row-active');
                thisRow.nextElementSibling.classList.add('active');
              }
            }
          });

          // keyboard navigation
          toggleBtns[j].addEventListener('keyup', function (event) {
            event.preventDefault();
            if (event.keyCode === 13) {
              event.currentTarget.click();
            }
          });
        }
      }
    },
    setupAnchorLinks: function (anchorLinksElem) {
      var sections = [],
        throttledAnchorLinksUpdate = OKJS.Global.throttle(
          function () {
            OKJS.Blocks.anchorLinksUpdate(anchorLinksElem, sections);
          },
          100,
          { trailing: false }
        ),
        throttledAnchorLinksUpdateCons = OKJS.Global.throttle(
          function () {
            OKJS.Blocks.anchorLinksUpdateCons(anchorLinksElem, sections);
          },
          500,
          { trailing: true }
        ),
        anchorLinks = anchorLinksElem.querySelectorAll('.anchor-links__item');

      // go through the anchorlinks
      for (var i = 0; i < anchorLinks.length; i++) {
        // test if the href has a value
        if (anchorLinks[i].getAttribute('href') !== '') {
          // test if the element that's referred to, is in the dom
          var anchorTarget = document.querySelector(
            anchorLinks[i].getAttribute('href')
          );

          if (anchorTarget !== null) {
            // push into section array
            sections.push(anchorLinks[i].hash);

            // click event for the anchor links
            anchorLinks[i].addEventListener('click', function (e) {
              e.preventDefault();
              var anchorTarget = document.querySelector(e.currentTarget.hash);

              animateScrollTo(anchorTarget, { offset: -75 });
            });
          }
        }
      }

      // there's no sticky nav on mobile
      if (anchorLinksElem && window.innerWidth > 480) {
        window.addEventListener(
          'scroll',
          function () {
            requestAnimationFrame(throttledAnchorLinksUpdate);
          },
          Modernizr.passiveeventlisteners ? { passive: true } : false
        );
        window.addEventListener(
          'resize',
          function () {
            requestAnimationFrame(throttledAnchorLinksUpdateCons);
          },
          Modernizr.passiveeventlisteners ? { passive: true } : false
        );

        // set cons
        OKJS.Blocks.anchorLinksUpdateCons(anchorLinksElem, sections);

        // run the update onload
        OKJS.Blocks.anchorLinksUpdate(anchorLinksElem, sections);
      }
    },
    anchorLinksUpdate: function (anchorLinksElem, sections) {
      var st = window.pageYOffset || document.documentElement.scrollTop;

      // make the anchor-links parent is sticky if it's past it's own top
      if (st > anchorLinksElem.dataset.top) {
        if (!anchorLinksElem.classList.contains('anchor-links--sticky')) {
          anchorLinksElem.classList.add('anchor-links--sticky');
        }
      } else {
        anchorLinksElem.classList.remove('anchor-links--sticky');
      }

      // scrollspy event
      for (var i = 0; i < sections.length; i++) {
        if (document.querySelector(sections[i]).dataset.top <= st) {
          var activeLink = document.querySelector(
            '.anchor-links__item--active'
          );

          // reset the active class
          if (activeLink) {
            activeLink.classList.remove('anchor-links__item--active');
          }

          // set the active class
          document
            .querySelector('a[href*="' + sections[i] + '"]')
            .classList.add('anchor-links__item--active');

          //break;
        }
      }
    },
    anchorLinksUpdateCons: function (anchorLinksElem, sections) {
      // set the top data attribute
      for (var i = 0; i < sections.length; i++) {
        var section = document.querySelector(sections[i]);
        section.dataset.top =
          section.getBoundingClientRect().top + window.pageYOffset ||
          document.documentElement.scrollTop;
      }

      // mark the top position of the anchor links element
      anchorLinksElem.dataset.top =
        anchorLinksElem.getBoundingClientRect().top + window.pageYOffset ||
        document.documentElement.scrollTop;

      // set height on the anchor links parent - to make sure the space is saved for when it returns
      anchorLinksElem.parentElement.style.height =
        anchorLinksElem.parentElement.clientHeight + 'px';

      // set the left margin so that it stayes within the content area

      var navElement = document.querySelector('.page-main__nav'),
        mainElement = document.querySelector('#pageMainWrap'),
        navWidth = navElement ? navElement.clientWidth : 0,
        pageMargin = mainElement
          ? (document.body.clientWidth - mainElement.clientWidth) / 2
          : 0,
        anchorLeft = navWidth + (pageMargin >= 0 ? pageMargin : 0);

      anchorLinksElem.style.left = anchorLeft + 'px';
      anchorLinksElem.style.right = (pageMargin >= 0 ? pageMargin : 0) + 'px';
    },
    setupCcSliders: function (ccSliders) {
      for (var i = 0; i < ccSliders.length; i++) {
        var slider = ccSliders[i],
          sliderWrap = slider.querySelector('.cblock-slider__wrap'),
          sliderNav = slider.querySelector('.cblock-slider__nav'),
          sliderNavItems = sliderNav.querySelectorAll('input');

        // set the correct nav position at load - this inflicts with the color of the navbar if it's on the same side as the text.
        //// We expect that the editor sets the same text position for all the sliding elements.
        imgAndNavSameSide =
          (slider.classList[2].indexOf('left') !== -1) ===
          (sliderWrap.querySelector('.cblock').classList[2].indexOf('left') !==
            -1);

        if (!imgAndNavSameSide) {
          slider.classList.add('cblock-slider--nav-on-text-side');
        }

        // set the correct nav color at load
        sliderNav.classList.add(
          'cblock-slider__nav--' +
            sliderWrap
              .querySelector('.cblock')
              .querySelector('.cblock__txt')
              .classList[1].split('--')[1]
        );

        // setup the click/change event on the navigation
        for (var j = 0; j < sliderNavItems.length; j++) {
          var slideEvent = {
            sliderWrap: sliderWrap,
            sliderNavItem: sliderNavItems[j],
            sliderNav: sliderNav,
            change: function () {
              // animate the element
              var swipeLeft =
                this.sliderNavItem.dataset.sliderindex * -100 + '%';

              // set the bg class for the nav
              this.sliderNav.className = 'cblock-slider__nav';
              this.sliderNav.classList.add(
                'cblock-slider__nav--' +
                  this.sliderWrap
                    .querySelectorAll('.cblock')
                    [this.sliderNavItem.dataset.sliderindex].querySelector(
                      '.cblock__txt'
                    )
                    .classList[1].split('--')[1]
              );
              this.sliderWrap.style.left = swipeLeft;
            },
          };

          // bind change event
          sliderNavItems[j].addEventListener(
            'change',
            slideEvent.change.bind(slideEvent)
          );
        }
      }
    },
    setupFactsScrolls: function (factsBlocks) {
      OKJS.Blocks.setupFactsScrolls.throttledfactsFadeInUpdate =
        OKJS.Global.throttle(
          function () {
            OKJS.Blocks.factsFadeIn(factsBlocks);
          },
          100,
          { trailing: false }
        );

      OKJS.Blocks.setupFactsScrolls.factsCount = 0;

      window.addEventListener(
        'scroll',
        OKJS.Blocks.setupFactsScrolls.throttledfactsFadeInUpdate,
        Modernizr.passiveeventlisteners ? { passive: true } : false
      );

      OKJS.Blocks.factsFadeIn(factsBlocks);
    },
    factsFadeIn: function (factsBlocks) {
      for (i = 0; i < factsBlocks.length; ++i) {
        if (
          OKJS.Global.isElementInViewport(factsBlocks[i]) &&
          !factsBlocks[i].classList.contains('show')
        ) {
          factsBlocks[i].classList.add('show');
          OKJS.Blocks.setupFactsScrolls.factsCount++;
        }
        if (OKJS.Blocks.setupFactsScrolls.factsCount === factsBlocks.length) {
          window.removeEventListener(
            'scroll',
            OKJS.Blocks.setupFactsScrolls.throttledfactsFadeInUpdate,
            Modernizr.passiveeventlisteners ? { passive: true } : false
          );
        }
      }
    },
    setupElToggles: function (elToggles) {
      for (i = 0; i < elToggles.length; i++) {
        var elToggle = elToggles[i];
        var elToggleInput = elToggle.querySelector('input');

        OKJS.Blocks.setToggleProductState(
          elToggle.parentElement,
          elToggleInput.checked
        );

        elToggleInput.addEventListener('change', function () {
          OKJS.Blocks.toggleProducts(event);
        });
      }
    },
    toggleProducts: function (event) {
      var toggleParent =
        event.target.parentElement.parentElement.parentElement.parentElement;

      OKJS.Blocks.setToggleProductState(toggleParent, event.target.checked);
    },
    setToggleProductState: function (toggleParent, state) {
      if (state === true) {
        toggleParent
          .querySelector('.js-elprdc-items')
          .classList.add('elprdc__items--toggled');
      } else {
        toggleParent
          .querySelector('.js-elprdc-items')
          .classList.remove('elprdc__items--toggled');
      }
    },
  };
})(window.OKJS);
